/**
 * The sharing relationship between the current user and a shareable item
 * (chat session, project), as surfaced in the sidebar sections.
 *
 * - `private` — you own it and it isn't shared with anyone else.
 * - `shared_with_me` — someone shared it with you.
 * - `shared_by_me` — you own it and shared it with at least one other person.
 */
export type SharingRelationship = "private" | "shared_with_me" | "shared_by_me"

/** The sidebar "All | Shared: With me · By me" filter. */
export type ShareFilter = "all" | "with_me" | "by_me"

export const SHARE_FILTERS: ShareFilter[] = ["all", "with_me", "by_me"]

export function isShareFilter(value: string | null): value is ShareFilter {
  return value === "all" || value === "with_me" || value === "by_me"
}

/** Whether an item with the given relationship should appear under the active filter. */
export function matchesShareFilter(
  relationship: SharingRelationship,
  filter: ShareFilter
): boolean {
  if (filter === "all") return true
  if (filter === "with_me") return relationship === "shared_with_me"
  return relationship === "shared_by_me"
}
